export default "__VITE_ASSET__CESjDl8z__"